/**
 * Web コンソールの指定リソース着地パス（`openConsole` の `next`）を組み立てる。
 *
 * コンソールは `open=<種別>:<id>` の繰り返し指定を解釈し、`task` / `project` / `source` /
 * `portal-source` / `output` / `format` を受ける。アドインは狭い縦 1 列でファイルの中身を読むのに
 * 向かないため、**一覧の行はリンクに留めて実体の表示をコンソールへ委ねる**
 * （[[2026-08-12 設計ノート アドインのAWS連携追随]]）。
 *
 * 既存の `consoleNextForSourceTask`（生成元タスクへの一点着地）と同じ形。
 */

/** 受領データ（手動アップロード）へ着地する。 */
export function consoleNextForSource(sourceId: string): string {
    return `/slide-studio?open=source:${encodeURIComponent(sourceId)}`;
}

/**
 * ポータル資料へ着地する。
 *
 * ポータル資料の同一性は案件と由来識別子の組が持つため、`案件id:ref` を畳んだものが resourceId に
 * なる。**案件が確定していないと組み立てられない**ので、新規案件の作成前は null を返す
 * （呼び出し側はリンクを出さない）。
 */
export function consoleNextForPortalSource(
    projectId: string | null,
    portalRef: string | undefined
): string | null {
    if (!projectId || !portalRef) return null;
    return `/slide-studio?open=portal-source:${encodeURIComponent(`${projectId}:${portalRef}`)}`;
}
